/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Course = {
    id?: string;
    slug?: string;
    title?: string;
    summary?: string;
    coverUrl?: string;
    status?: Course.status;
    priceCents?: number | null;
    currency?: string;
    authorName?: string;
    tags?: Array<string>;
    defaultLanguage?: string;
    availableLanguages?: Array<string>;
    visibility?: Course.visibility;
    /**
     * Named render theme preset (empty = platform default).
     */
    theme?: string;
    ownerId?: string;
    ownerEmail?: string;
    registeredCount?: number;
    ratingAvg?: number | null;
    ratingCount?: number;
    createdAt?: string;
    updatedAt?: string;
};
export namespace Course {
    export enum status {
        DRAFT = 'draft',
        PUBLISHED = 'published',
        ARCHIVED = 'archived',
    }
    export enum visibility {
        PUBLIC = 'public',
        PRIVATE = 'private',
    }
}

